import api from "./client";

export const getEnquiries = (params) => api.get("/enquiries", { params });
export const getEnquiry = (enquiryId) => api.get(`/enquiries/${enquiryId}`);
export const createEnquiry = (data) => api.post("/enquiries", data);
export const updateEnquiry = (enquiryId, data) => api.patch(`/enquiries/${enquiryId}`, data);
export const updateEnquiryStatus = (enquiryId, status, { lostReason, lostNote } = {}) =>
  api.patch(`/enquiries/${enquiryId}/status`, {
    status,
    ...(lostReason && { lost_reason: lostReason }),
    ...(lostNote && { lost_note: lostNote }),
  });
export const dismissEnquiry = (enquiryId) => api.post(`/enquiries/${enquiryId}/dismiss`);
export const addEnquirySegment = (enquiryId, data) => api.post(`/enquiries/${enquiryId}/add-segment`, data);
export const removeEnquirySegment = (enquiryId, childId) => api.delete(`/enquiries/${enquiryId}/segments/${childId}`);
export const mergeEnquirySegments = (enquiryId, data = {}) => api.post(`/enquiries/${enquiryId}/merge-segments`, data);
export const sendMultiSegmentQuote = (parentEnquiryId, quoteIds) =>
  api.post('/quotes/send-multi-segment', { parent_enquiry_id: parentEnquiryId, quote_ids: quoteIds });
export const deleteEnquiry = (enquiryId, { force = false, actor } = {}) =>
  api.delete(`/enquiries/${enquiryId}`, {
    params: { ...(force ? { force: true } : {}), ...(actor ? { actor } : {}) },
  });
export const getEnquiryDeleteImpact = (enquiryId) => api.get(`/enquiries/${enquiryId}/delete-impact`);
export const autocompleteContacts = (query) => api.get("/enquiries/contacts/autocomplete", { params: { q: query } });
export const reconcileEnquiryParent = (enquiryId) => api.post(`/enquiries/${enquiryId}/reconcile-parent`);
export const validateEnquiry = (data) => api.post("/enquiries/validate", data);
export const proposeTransition = (enquiryId, transitionName, context = {}, execute = false) =>
  api.post(`/enquiries/${enquiryId}/propose-transition`, {
    transition_name: transitionName,
    context,
    ...(execute ? { execute: true } : {}),
  });
export const assignEnquiry = (enquiryId, assignee, source = "web_ui") =>
  api.patch(`/enquiries/${enquiryId}/assign`, { assignee, source });
export const addEnquiryNote = (enquiryId, note, source = "web_ui", author = null) =>
  api.post(`/enquiries/${enquiryId}/notes`, { note, source, author });
export const changeEnquiryClient = (enquiryId, clientId) =>
  api.patch(`/enquiries/${enquiryId}/client`, { client_id: clientId, source: "web_ui" });
export const getLifecycleStates = () => api.get("/enquiries/lifecycle-states");
export const getEnquiryActivities = (enquiryId, params) =>
  api.get(`/enquiries/${enquiryId}/activities`, { params });
export const splitPendingComm = (enquiryId) =>
  api.post(`/enquiries/${enquiryId}/split-pending-comm`);
export const dismissSplitSuggestion = (enquiryId) =>
  api.post(`/enquiries/${enquiryId}/dismiss-split-suggestion`);

// Supplier-origin controls
export const dismissSupplierOrigin = (enquiryId) => api.post(`/enquiries/${enquiryId}/supplier-origin/dismiss`);
export const confirmSupplierOrigin = (enquiryId) => api.post(`/enquiries/${enquiryId}/supplier-origin/confirm`);

// Branded PowerPoint of the client's requirements (no quotes needed). Returns a blob.
export const downloadRequirementsDeck = (enquiryId) =>
  api.post(`/enquiries/${enquiryId}/requirements-deck`, null, { responseType: "blob", timeout: 180000 });
export const getSophiePlan = (enquiryId) => api.get(`/enquiries/${enquiryId}/sophie-plan`);
export const getSophieJournal = (enquiryId, params) => api.get(`/enquiries/${enquiryId}/sophie-journal`, { params });
export const setEnquiryLeadChannel = (enquiryId, channel, reason = "") =>
  api.put(`/lead-channels/enquiries/${enquiryId}`, { channel, reason });
